import React from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

export default function PlaceAutocomplete({ value, onChange, placeholder = 'Enter an address', name, ...rest }) {
  const handleSelect = (address) => {
    onChange(address);
    // optional: resolve lat/lng for downstream use
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        // no-op for now, but useful for debugging
        // console.log('Selected latLng', latLng);
      })
      .catch((err) => {
        // silent
      });
  };

  return (
    <PlacesAutocomplete value={value} onChange={onChange} onSelect={handleSelect}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div className="relative w-full">
          <input
            {...getInputProps({
              placeholder,
              name,
              className:
                'w-full px-[16px] py-[14px] border border-gray-300 rounded-[8px] text-[16px] font-satoshi focus:outline-none focus:ring-2 focus:ring-[#FFBD00] focus:border-transparent',
              ...rest,
            })}
          />
          <div className="absolute z-50 w-full mt-[4px] bg-white  rounded-[8px] shadow-lg max-h-[300px] overflow-y-auto">
            {loading && <div className="px-[16px] py-[12px] text-gray-500 text-[14px]">Loading...</div>}
            {suggestions.map((suggestion) => {
              const className = suggestion.active
                ? 'px-[16px] py-[12px] cursor-pointer bg-gray-100 transition-colors text-[14px] font-satoshi border-b border-gray-100 last:border-b-0'
                : 'px-[16px] py-[12px] cursor-pointer hover:bg-gray-100 transition-colors text-[14px] font-satoshi border-b border-gray-100 last:border-b-0';

              return (
                <div {...getSuggestionItemProps(suggestion, { className })} key={suggestion.placeId}>
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
}
